import React from 'react';
import ReactDOM from 'react-dom';
import Popup from './Popup';
import shouldShow from './should-show';
import {
    pageTrackEidVerificationModalPopup,
    onModalClose,
    onBankIdVerify,
} from './tracker';

window.addEventListener('DOMContentLoaded', () => {
    const content = document.getElementById('eid-verification-popup-podlet');
    if (content && shouldShow()) {
        ReactDOM.render(
            <Popup
                onModalClose={onModalClose}
                onBankIdVerify={onBankIdVerify}
            />,
            content,
        );
        pageTrackEidVerificationModalPopup();
    }
});
